import { render, staticRenderFns } from "./WarehouseCekOngkir.vue?vue&type=template&id=f689c5d0&scoped=true"
import script from "./WarehouseCekOngkir.vue?vue&type=script&lang=js"
export * from "./WarehouseCekOngkir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f689c5d0",
  null
  
)

export default component.exports